// Страница документа (макет «Документ»): полный текст с сервера. Текст — из legal/*.md, сервер
// превращает его в HTML без сырого HTML; дата редакции — первой строкой текста.
import { useParams } from "react-router";
import { isApiError } from "../../api/client";
import { useDocument } from "../../app/queries";
import { SiteFooter } from "../../site/SiteFooter";
import { useIsMiniApp } from "../../telegram/channel";
import { Button } from "../../ui/Button";
import { PageHeader } from "../../ui/PageHeader";
import { NotFoundScreen } from "../../ui/ProblemScreen";
import { Screen } from "../../ui/Screen";
import styles from "./Docs.module.css";
import { DocsOffline, useDocsFooterLinks } from "./DocsScreen";

export function DocPageScreen() {
  const { documentId = "" } = useParams();
  const isMiniApp = useIsMiniApp();
  const footerLinks = useDocsFooterLinks();
  const { data: document, error, failureReason, refetch } = useDocument(documentId);
  if (document === undefined) {
    if (isApiError(error) && error.kind === "not_found") return <NotFoundScreen />;
    if (isApiError(failureReason) && failureReason.kind === "network") {
      return <DocsOffline onRetry={() => void refetch()} />;
    }
  }
  return (
    <>
      <Screen direction="miniature" header={<PageHeader title="Документы" backTo="/docs" />}>
        <div className={styles.content} id="top">
          {document === undefined ? (
            <p role="status" className="text muted">
              Загружаем текст документа…
            </p>
          ) : (
            <>
              <div className={styles.titleBlock}>
                <p className={styles.eyebrow}>документ</p>
                <h1 className="h2">{document.heading}</h1>
              </div>
              {/* HTML собран сервером из файла документа: сырой HTML в нём экранирован. */}
              <div className={styles.legalText} dangerouslySetInnerHTML={{ __html: document.html }} />
            </>
          )}
          <div className={styles.bottomActions}>
            <Button variant="secondary" to="/docs">
              Все документы
            </Button>
            <Button variant="text" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
              Наверх
            </Button>
          </div>
        </div>
      </Screen>
      {!isMiniApp && <SiteFooter links={footerLinks} />}
    </>
  );
}
